<template>
  <div>
    <base-header type="gradient-success" class="py-5"></base-header>
    <div class="container-fluid" style="margin-top: 2rem;">
      <slot />
    </div>
  </div>
</template>

<script>
const url = "/bo-react/";

export default {
  name: "ReactPage",
  mounted() {
    if (typeof window['emsReactScript'] === 'undefined') {
      window['emsReactScript'] = document.createElement('script');
      window['emsReactScript'].type = 'module';
      window['emsReactScript'].crossOrigin = 'anonymous';
      window['emsReactScript'].src = url + 'app.js';
      document.head.appendChild(window['emsReactScript']);
    }
    if (typeof window['emsReactStyleLink'] === 'undefined') {
      window['emsReactStyleLink'] = document.createElement('link');
      window['emsReactStyleLink'].rel = 'stylesheet';
      window['emsReactStyleLink'].crossOrigin = 'anonymous';
      window['emsReactStyleLink'].href = url + 'assets/style.css';
      document.head.appendChild(window['emsReactStyleLink']);
    }
  },
  destroyed() {
    window['emsReactScript'].parentNode.removeChild(window['emsReactScript']);
    delete window['emsReactScript'];
    window['emsReactStyleLink'].parentNode.removeChild(window['emsReactStyleLink']);
    delete window['emsReactStyleLink'];
  },
}
</script>